<button class="button " 
  (click)="clickHandler()" 
  (mouseover)="onMouseOver()"
  (mouseout)="onMouseOut()"
  [disabled]="disabled" 
  [ngClass]="[buttonType, iconType ? 'button-icon': '' ]"
  [ngStyle]="buttonStyle">
  <pre careposi-tooltip [tooltipEnabled]="tooltipEnabled">{{buttonText}}</pre>
</button>